/**
 * Construcción del RepoSet para el backend SUPABASE/PostgREST.
 *
 * Sirve a DOS perfiles de despliegue con el mismo código:
 *   - CLOUDFLARE: Supabase gestionado (piloto actual en producción).
 *   - AZURE: PostgREST sobre Azure Database for PostgreSQL + identidad Entra
 *     (VITE_DATA_AUTH=entra) + RLS. Mismo adaptador, distinta URL/identidad.
 *
 * Aislado en su propio módulo para tree-shaking (ver `repos.ts`).
 * `configuracionIA` queda en Dexie A PROPÓSITO (claves de IA sensibles que no
 * deben vivir en la tabla compartida) — es la única dependencia local.
 */

import { SupabaseAfeRepo } from "./adapters/supabase/SupabaseAfeRepo";
import { SupabaseUsuarioRepo } from "./adapters/supabase/SupabaseUsuarioRepo";
import { SupabaseBudgetRepo } from "./adapters/supabase/SupabaseBudgetRepo";
import { SupabaseCosteCatalogoRepo } from "./adapters/supabase/SupabaseCosteCatalogoRepo";
import { SupabasePrRepo } from "./adapters/supabase/SupabasePrRepo";
import { SupabasePoRepo } from "./adapters/supabase/SupabasePoRepo";
import { SupabaseMrRepo } from "./adapters/supabase/SupabaseMrRepo";
import { SupabaseGastoSapRepo } from "./adapters/supabase/SupabaseGastoSapRepo";
import { SupabaseRegistroRecursosRepo } from "./adapters/supabase/SupabaseRegistroRecursosRepo";
import { SupabaseAuditLogRepo } from "./adapters/supabase/SupabaseAuditLogRepo";
import { SupabaseMejoraRepo } from "./adapters/supabase/SupabaseMejoraRepo";
import { SupabaseSoRepo } from "./adapters/supabase/SupabaseSoRepo";
import { SupabaseRdRepo } from "./adapters/supabase/SupabaseRdRepo";
import { SupabaseActaRepo } from "./adapters/supabase/SupabaseActaRepo";
import { SupabaseEventoRepo } from "./adapters/supabase/SupabaseEventoRepo";
import { SupabaseContratoMarcoRepo } from "./adapters/supabase/SupabaseContratoMarcoRepo";
import { SupabaseRiesgoRepo } from "./adapters/supabase/SupabaseRiesgoRepo";
import { SupabaseStakeholderRepo } from "./adapters/supabase/SupabaseStakeholderRepo";
import { SupabaseNotificacionConfigRepo } from "./adapters/supabase/SupabaseNotificacionConfigRepo";
import { SupabaseListaDistribucionRepo } from "./adapters/supabase/SupabaseListaDistribucionRepo";
import { SupabaseNotificacionEnviadaRepo } from "./adapters/supabase/SupabaseNotificacionEnviadaRepo";
import { SupabaseCatalogoRiesgosRepo } from "./adapters/supabase/SupabaseCatalogoRiesgosRepo";
import { SupabaseComisionamientoRepo } from "./adapters/supabase/SupabaseComisionamientoRepo";
import { DexieConfiguracionIARepo } from "./adapters/dexie/DexieConfiguracionIARepo";
import type { RepoSet } from "./repos";

export function buildSupabaseRepos(tenantId: string): RepoSet {
  return {
    afe: new SupabaseAfeRepo(tenantId),
    usuario: new SupabaseUsuarioRepo(tenantId),
    budget: new SupabaseBudgetRepo(tenantId),
    costeCatalogo: new SupabaseCosteCatalogoRepo(tenantId),
    pr: new SupabasePrRepo(tenantId),
    po: new SupabasePoRepo(tenantId),
    mr: new SupabaseMrRepo(tenantId),
    gastoSap: new SupabaseGastoSapRepo(tenantId),
    registroRecursos: new SupabaseRegistroRecursosRepo(tenantId),
    mejora: new SupabaseMejoraRepo(tenantId),
    so: new SupabaseSoRepo(tenantId),
    rd: new SupabaseRdRepo(tenantId),
    acta: new SupabaseActaRepo(tenantId),
    evento: new SupabaseEventoRepo(tenantId),
    contrato: new SupabaseContratoMarcoRepo(tenantId),
    riesgo: new SupabaseRiesgoRepo(tenantId),
    stakeholder: new SupabaseStakeholderRepo(tenantId),
    notificacionConfig: new SupabaseNotificacionConfigRepo(tenantId),
    listaDistribucion: new SupabaseListaDistribucionRepo(tenantId),
    notificacionEnviada: new SupabaseNotificacionEnviadaRepo(tenantId),
    catalogoRiesgos: new SupabaseCatalogoRiesgosRepo(tenantId),
    comisionamiento: new SupabaseComisionamientoRepo(tenantId),
    // ConfiguracionIA permanece local A PROPÓSITO (claves de IA sensibles).
    configuracionIA: new DexieConfiguracionIARepo(tenantId),
    auditLog: new SupabaseAuditLogRepo(tenantId),
  };
}
